// extracted by mini-css-extract-plugin
export var cardHeader = "_i0-1";
export var contentCard = "_i0-0";
export var headerActions = "_i0-3";
export var reorderHandle = "_i0-5";
export var titleArea = "_i0-2";
export var titleAreaWithHandle = "_i0-4";